import { render, staticRenderFns } from "./spereindic.vue?vue&type=template&id=3ec1b941&scoped=true&"
import script from "./spereindic.vue?vue&type=script&lang=js&"
export * from "./spereindic.vue?vue&type=script&lang=js&"
import style0 from "./spereindic.vue?vue&type=style&index=0&id=3ec1b941&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec1b941",
  null
  
)

export default component.exports